import React from 'react';
import clsx from 'clsx';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { getPathname } from 'utils/common/common';
import styles from '../Navigation.module.css';

type TProps = {
  href: string;
  label: string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
};

export const NavItemLink = ({
  href,
  label,
  onClick,
  className,
  disabled,
}: TProps) => {
  const router = useRouter();

  return (
    <div
      className={clsx(
        styles.navItem,
        { [styles.disabled]: disabled },
        className,
      )}
    >
      <Link
        href={href}
        passHref
        onClick={onClick}
        className={clsx(styles.navItemLink, {
          [styles.navItemLinkActive]: router.pathname === getPathname(href),
        })}
        data-testid={`${href.substring(1)}-link`}
      >
        <span>{label}</span>
      </Link>
    </div>
  );
};
